import * as React from "react";
import { useState } from "react";
import QuestionHeading from "./QuestionHeading";
import List from "@mui/material/List";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import { TApiAnswerEntity, TApiQuestionEntity } from "../../types/Survey";
import ListItem from "@mui/material/ListItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FeedbackIcon from "@mui/icons-material/Feedback";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import QuestionHelpTextModal from "../modals/QuestionHelpTextModal";
import SurveyTranslation from "./SurveyTranslation";
import makeStyles from '@mui/styles/makeStyles';
import { Theme, useMediaQuery, useTheme } from '@mui/material';

interface IQuestionPageProps {
  question: TApiQuestionEntity;
  selectedAnswer: any;
  questionRequired: string | null;
  questionSkipButton: string | null;
  handleAnswerSubmit: (answerId: number) => void;
  comment: string;
  redirectToNextQuestion: (storeQuestion: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  chip: {
    backgroundColor: "orange",
  },
  reportCaseButton: {
    backgroundColor: "white",
  },
  answerButton: {
    border: "1px solid #e8e8e8",
    borderRadius: "8px",
    marginBottom: "8px",
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "1px 1px 2px 0px rgba(0,0,0,0.15)",
  },
}));

const Question: React.FC<IQuestionPageProps> = ({
  question,
  selectedAnswer,
  questionRequired,
  questionSkipButton,
  handleAnswerSubmit,
  comment,
  redirectToNextQuestion,
}): JSX.Element => {
  const [modalOpen, setModalOpen] = useState(false);
  const classes = useStyles({});
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <QuestionHelpTextModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        question={question}
      />
      <QuestionHeading question={question} setModalOpen={setModalOpen} />
      <List component="nav" aria-label="secondary mailbox folder">
        <FormControl component="fieldset" style={{ width: "100%" }}>
          <RadioGroup
            aria-label="gender"
            name="gender1"
            value={selectedAnswer?.id || ""}
          >
            <List component="nav" aria-labelledby="nested-list-subheader">
              {question.answers.map((answer: TApiAnswerEntity) => {
                return (
                  <ListItem
                    button
                    key={answer.id}
                    onClick={() => handleAnswerSubmit(answer.id)}
                    className={classes.answerButton}
                  >
                    <FormControlLabel
                      value={answer.id}
                      control={<Radio />}
                      label={answer?.title}
                    />
                    {selectedAnswer &&
                      answer &&
                      selectedAnswer?.id === answer?.id &&
                      comment && <FeedbackIcon />}
                  </ListItem>
                );
              })}
            </List>
          </RadioGroup>
        </FormControl>
      </List>
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item xs={isXs ? 6 : 3} style={{ alignSelf: "center", textAlign: "right" }}>
          {question.mandatory ? (
            <Chip
              label={
                questionRequired !== null ? (
                  questionRequired
                ) : (
                  <SurveyTranslation
                    translate={"survey.question.required.label"}
                  />
                )
              }
              classes={{
                root: classes.chip,
              }}
            />
          ) : (
            <Button
              fullWidth
              color="primary"
              onClick={() => redirectToNextQuestion(true)}
            >
              {questionSkipButton !== null ? (
                questionSkipButton
              ) : (
                <SurveyTranslation translate={"survey.question.skip"} />
              )}
            </Button>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Question;
